import type { DocumentError } from 'apiConnector/document/document';
import { documentApi } from 'apiConnector/document/document';
import type { BlobFileResponse } from 'models/FileResponse';
import type { IBlotterItem } from 'models/IBlotterItem';
import { useCallback, useState } from 'react';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { downloadFile } from 'utils/documents/downloadDocument';
import { getMarketingMaterialsFilename } from 'utils/documents/filenames';

export const useDownloadMarketingMaterials = () => {
  const [error, setError] = useState<DocumentError | undefined>(undefined);
  const [isDownloading, setIsDownloading] = useState(false);

  const download = useCallback((productId: string, blotterItem: IBlotterItem) => {
    setIsDownloading(true);

    const document$: Observable<BlobFileResponse> = documentApi.downloadMarketingMaterials(productId).pipe(
      finalize(() => {
        setIsDownloading(false);
      }),
    );
    document$.subscribe({
      next({ data, filename }: BlobFileResponse) {
        const name = filename === undefined || filename === '' ? getMarketingMaterialsFilename(blotterItem) : filename;
        downloadFile(data, `${name}.pdf`);
        setError(undefined);
      },
      error(err: DocumentError) {
        setError(err);
      },
    });
  }, []);

  return {
    isDownloading,
    download,
    error,
  };
};
